export default function ValidatePassword() {
  var valid = true;
  var rfvPass = $("#rfvPass");
  var Password = $("input.tbxPass");
  rfvPass.hide();
  Password.removeClass("error");

  $.ajax({
    type: 'POST',
    dataType: 'json',
    contentType: "application/json",
    url: '/api/account/ValidatePassword',
    async: false,
    data: JSON.stringify(Password.val()),
    success: function (data) {
      if (!data.IsSuccess) {
        valid = false;
        rfvPass.show();
        rfvPass.text(data.Message);
        Password.addClass("error");
      }
    }
  });

  return valid;
}